import { Box, Container, IconButton } from "@mui/material";
import { useSSTheme } from "../hooks/useSSTheme";
import { SSText } from "src/components/base/components/SSText";
import { useSSAuth } from "../hooks/useSSAuth";
import { createState } from "src/utils/create_zustand_store";
import React from "react";
import { useRouterExt } from "../hooks/useRouterExt";
import { routes } from "src/shared/routes";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export const usePageTopNotification = createState({
  isOpen: false,
  title: (<></>) as string | React.ReactNode,
  description: (<></>) as string | React.ReactNode,
  route: "",
  backgroundColor: "",
});

export function PageTopNotification() {
  const router = useRouterExt();
  const theme = useSSTheme();
  const notificationState = usePageTopNotification();
  const isValidPath = router.pathname === notificationState.route;

  // sample trigger
  // React.useEffect(() => {
  //   notificationState.set({
  //     isOpen: true,
  //     route: routes.landing,
  //     title: "Welcome to the team Lorem ipsum dolor sit",
  //     description: "You have successfully joined the team",
  //   });
  // }, []);

  // listen to route change and reset/close notification
  React.useEffect(() => {
    const isRouteChanged = router.pathname !== notificationState.route;
    if (notificationState.isOpen && isRouteChanged) {
      notificationState.reset();
    }
  }, [router.pathname]);

  if (!notificationState.isOpen || !isValidPath) return null;

  return (
    <Box
      bgcolor={notificationState?.backgroundColor || theme.colors.teamPrimary}
      py={2}
      position={"relative"}
    >
      <Box position={"absolute"} top={"4px"} right={"4px"} zIndex={1}>
        <IconButton size="large" onClick={() => notificationState.reset()}>
          <CloseRoundedIcon sx={{ color: theme.colors.common.white }} />
        </IconButton>
      </Box>
      <Container maxWidth="lg" sx={{ position: "relative" }}>
        <Box pr={4}>
          <SSText
            variant="h6"
            fontSize={`1.1rem`}
            fontWeight={"700"}
            color={theme.colors.common.white}
            pr={"32px"}
          >
            {notificationState.title}
          </SSText>
          <SSText
            variant="body"
            mt={1}
            color={theme.colors.common.white}
            sx={{ opacity: 0.9 }}
          >
            {notificationState.description}
          </SSText>
        </Box>
      </Container>
    </Box>
  );
}
